import ArgonBadge from 'component/Argon/ArgonBadge';

const PendingBadge = <ArgonBadge variant="contained" color="error" size="xs" badgeContent="รอการชำระ" container />;
const PaidBadge = <ArgonBadge variant="contained" color="success" size="xs" badgeContent="จ่ายแล้ว" container />;

export { PendingBadge, PaidBadge };
